import React, { useEffect, useState } from "react";
import { func, number } from "prop-types";
import "./premium-pagination.m.css";

const PremiumPagination = ({ totalCount, perPage, currentPage = 1, loadStories }) => {
  // max limit 100000 similar to other pagination
  const totalNoItems = totalCount > 10000 ? 10000 : totalCount;
  const totalPages = Math.ceil(totalNoItems / perPage);

  if (totalPages <= 1) return null;

  const handlePageClick = (page) => {
    if (page < 1 || page > totalPages) return;
    loadStories?.(page);
  };

  // Limit to 5 pages max in the UI as per the design requirement
  // For a robust implementation we would slide this window, but keeping it simple for now
  const startPage = Math.max(1, Math.min(currentPage - 2, totalPages - 4));
  const endPage = Math.min(totalPages, startPage + 4);
  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return (
    <div styleName="premiumPagination">
      <button
        type="button"
        styleName="arrowBox"
        onClick={() => handlePageClick(currentPage - 1)}
        disabled={currentPage === 1}
        aria-label="Previous page"
      >
        &lt;
      </button>
      {pages.map((p) => (
        <button
          type="button"
          key={p}
          styleName={`numberBox ${p === currentPage ? "active" : ""}`}
          onClick={() => handlePageClick(p)}
          aria-current={p === currentPage ? "page" : undefined}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        styleName="arrowBox"
        onClick={() => handlePageClick(currentPage + 1)}
        disabled={currentPage === totalPages}
        aria-label="Next page"
      >
        &gt;
      </button>
    </div>
  );
};

PremiumPagination.propTypes = {
  totalCount: number.isRequired,
  perPage: number.isRequired,
  currentPage: number,
  loadStories: func
};

export default PremiumPagination;
